import { useState } from "react";

type FileExtension = ".pdf" | ".rar" | ".zip" | ".xlsx"

const useDownloadFile = () => {
    const [isDownloading, setIsDownloading] = useState<boolean>(false);

    // Devuelve si guardó el archivo, para que quien la llama no muestre un éxito sin descarga.
    const downloadFile = async (
        url: string,
        fileExtension: FileExtension,
        name?: string
    ): Promise<boolean> => {
        try {
            setIsDownloading(true);

            const response = await fetch(url);
            // fetch no falla ante un 403/404 de S3: sin esto se guardaría el XML del error.
            if (!response.ok) throw new Error(`La descarga respondió ${response.status}`);
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);

            const downloadLink = document.createElement('a');
            const fileName = name ? `${name}${fileExtension}` : `${name}${fileExtension}`;
            downloadLink.href = downloadUrl;
            downloadLink.download = fileName;
            downloadLink.click();

            window.URL.revokeObjectURL(downloadUrl);
            return true;
        } catch (error) {
            console.error('Error downloading the file:', error);
            return false;
        } finally {
            setIsDownloading(false);
        }
    };

    return { isDownloading, downloadFile };
};

export default useDownloadFile;
